module.exports = __webpack_public_path__ + "img/delete_tab.2407926c.svg";